import {Routes} from '@angular/router';

export const layerRecommendationRoutes: Routes = [
  {
    path: 'layerRecommendation',
    loadComponent: () => import('./layer-recommendation.component').then(m => m.LayerRecommendationComponent),
    data: { title: '弹框橱窗推荐' },
  },
];
